/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

import Card from "@mui/material/Card";
import { formatDate, formatCurrency } from "utils";
import SoftBox from "components/SoftBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell";
import { BonusPaymentTableService } from "services/bonus-payment-table";

const renderData = (items, setDataTable) => {
  return items.map((item) => ({
    id: item._id,
    unitNumber: item.unitNumber,
    year: item.year,
    quarter: item.quarter,
    totalEmployment: item.totalEmployment,
    totalBonus: formatCurrency.format(item.totalBonus),
    createdAt: formatDate(item.createdAt),
    action: <ActionCell item={item} index={item._id} setDataTable={setDataTable} />,
  }));
};
const tableData = {
  columns: [
    {
      Header: "Số",
      accessor: "unitNumber",
    },
    {
      Header: "Năm",
      accessor: "year",
    },
    {
      Header: "Quý",
      accessor: "quarter",
      width: "10%",
    },
    {
      Header: "Số lượng nhân viên",
      accessor: "totalEmployment",
    },
    {
      Header: "Tổng tiền thưởng",
      accessor: "totalBonus",
      width: "15%",
    },
    {
      Header: "Ngày tạo",
      accessor: "createdAt",
    },
    { Header: "Actions", accessor: "action", sorted: false },
  ],
  rows: [],
};

function BonusPaymentTable() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc" });
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 10,
  });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const response = await BonusPaymentTableService.getPaginate({
        ...query,
        page: paginationData.page,
        limit: paginationData.size,
      });

      const { items, paginate } = response.data || response;

      setPaginationData((prev) => ({
        ...prev,
        count: paginate?.count || 0,
        size: paginate?.size || 10,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items || [], setDataTable),
      }));

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Lỗi lấy dữ liệu bảng thưởng:", error);
      setDataTable((prev) => ({ ...prev, rows: [] }));
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default BonusPaymentTable;
